import React, { useState } from 'react';
import CopyLink from './copy_link';
import EmailLink from './email_link';
import TabPanel from './tab_panel';
import { Popover, Tab, Tabs } from '@mui/material';
import { withStyles } from '@mui/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ReplyIcon from '@mui/icons-material/Reply';

export default function QuickCheckShare() {
  const [anchorElement, setAnchorElement] = useState(null);
  const [currentTab, setCurrentTab] = useState(0);

  const handleClick = ({ currentTarget }) => {
    setAnchorElement(currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(null);
    setCurrentTab(0);
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const StyledTabs = withStyles({
    indicator: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      width: 140,
      minWidth: 140,
      '& > span': {
        width: 128,
        minWidth: 128,
      },
    },
  })((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

  const StyledFirstTab = withStyles((theme) => ({
    root: {
      minWidth: 72,
      marginRight: theme.spacing(4),
    },
    selected: {},
  }))((props) => <Tab disableRipple {...props} />);

  const StyledSecondTab = withStyles((theme) => ({
    root: {
      minWidth: 72,
      marginRight: theme.spacing(1),
    },
    selected: {},
  }))((props) => <Tab disableRipple {...props} />);

  return (
    <div className="quick-check-share">
      <div onClick={handleClick} className="popover-button-container">
        <button className="action-primary action-alt share-button">
          <ReplyIcon className="share-icon" />
          <span className="share-button-label">Share</span>
          <ArrowDropDownIcon className="dropdown-caret" />
        </button>
        <div className="popover-anchor" />
      </div>
      <Popover
        className="quick-check-share-popover"
        open={!!anchorElement}
        anchorEl={anchorElement}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div className="popover-container">
          <div className="popover-arrow" />
          <div className="popover-box">
            <StyledTabs
              value={currentTab}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <StyledFirstTab className={'qa-qc-share-copy-link-tab'} label="Copy Link" />
              <StyledSecondTab className={'qa-qc-share-email-link-tab'} label="Email Link" />
            </StyledTabs>
            <TabPanel value={currentTab} index={0}>
              <CopyLink />
            </TabPanel>
            <TabPanel value={currentTab} index={1}>
              <EmailLink close={handleClose} />
            </TabPanel>
          </div>
        </div>
      </Popover>
    </div>
  );
}
